import { render, staticRenderFns } from "./MessageChat.vue?vue&type=template&id=6ef10f06&"
import script from "./MessageChat.vue?vue&type=script&lang=js&"
export * from "./MessageChat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports